let api, url;
url = api = "http://192.168.1.248:5004";

if (document.domain != "0.0.0.0") {
    url = api = "https://api.prostatus.info/";
}

export default {
    api,
    url
};



// WEBPACK FOOTER //
// ./src/config.js